<ol class="breadcrumb float-xl-right">
  <li class="breadcrumb-item">Inicio</li>
  <li class="breadcrumb-item">Administración de Usuarios</li>
</ol>

<h1 class="page-header"><i class="fas fa-tachometer-alt"></i> Administración de Usuarios</h1>

<panel [noButton]="true">
  <div class="row">
    <div class="col-md-6">
      <input type="text" class="form-control form-control-sm" placeholder="Buscar usuario..." [(ngModel)]="search">
    </div>
    <div class="col-md-6 d-flex justify-content-between">
      <button class="btn btn-primary btn-sm" (click)="getUsers()">Buscar</button>
      <button class="btn btn-primary btn-sm" (click)="open(modalUserForm)">Nuevo Usuario</button>
    </div>
  </div>
  @if(users.length > 0){
  <div class="row p-5">
    <table class="table table-sm border">
      <thead>
        <tr>
          <th>N°</th>
          <th class="text-center">Email</th>
          <th>Nombre</th>
          <th>Rol</th>
          <th>Campo</th>
          <th>Entidad</th>
          <th class="text-center">Habilitado</th>
          <th class="text-center"><i class="fas fa-cogs"></i></th>
        </tr>
      </thead>
      <tbody>
        @for(user of users; track $index){
        <tr>
          <td class="text-center">{{ $index + 1 }}</td>
          <td>{{ user.mail }}</td>
          <td>{{ user.displayName }}</td>
          <td>{{ user.role?.name }}</td>
          <td>{{ user.office?.acronym }}</td>
          <td>{{ user.entity?.name }}</td>
          <td>
            <div class="form-check form-switch d-flex justify-content-center">
              <input class="form-check-input" type="checkbox" id="checkbox1" [checked]="user.enabled"
                (change)="updateUser(user, !user.enabled)" />
            </div>
          </td>
          <td class="text-center">
            <button class="btn btn-xs btn-primary mx-2" (click)="open(modalUserForm, user)" ngbTooltip="Revisar Evaluación"><i
                class="fas fa-eye"></i></button>
          </td>
        </tr>
        }
        @empty{
        <tr>
          <td colspan="7" class="text-center">No hay registros</td>
        </tr>
        }
      </tbody>
    </table>
  </div>
  }
</panel>


<ng-template #modalUserForm let-c="close" let-d="dismiss">

  <div class="modal-header">
    <span class="fs-3 fw-700">Datos Usuario</span>
  </div>
  <div class="modal-body" [formGroup]="newUserForm">
    <div class="row py-3">

      <div class="col-md-6">
        <label class="form-label col-form-label col-md-3">Email</label>
        <input type="email" class="form-control" placeholder="" formControlName="mail" />
      </div>
      <div class="col-md-6">
        <label class="form-label col-form-label col-md-3">Rol</label>
        <ng-select [items]="roles" bindLabel="name" bindValue="id" formControlName="roleId" dropdownPosition="auto"
          appendTo="body" [clearable]="false"></ng-select>
      </div>
      <div class="col-md-6">
        <label class="form-label col-form-label col-md-3">Campo</label>
        <ng-select [items]="offices" bindLabel="name" bindValue="id" formControlName="officeId" dropdownPosition="auto"
          appendTo="body" [clearable]="false"></ng-select>
      </div>
      <div class="col-md-6">
        <label class="form-label col-form-label col-md-3">Entidad</label>
        <ng-select [items]="entities" bindLabel="name" bindValue="id" formControlName="entityId" dropdownPosition="auto"
          appendTo="body" [clearable]="false"></ng-select>
      </div>
    </div>

  </div>

  <div class="modal-footer">
    <button class="btn btn-danger" (click)="d('Cross click')">Cerrar</button>
    <button class="btn btn-primary" (click)="d('Cross click'); saveUser()">Guardar</button>
  </div>
</ng-template>